import React from 'react';
import { ErrorBoundary } from 'Components/organisms/ErrorBoundary';

const withErrorBoundary = (Component) => {
  const ErrorBoundaryComponent = (props) => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );

  return ErrorBoundaryComponent;
};

export default withErrorBoundary;
